/**
 * Reducer for obtaining navigation steps
 */
import Constants from '../constants/NavigationConstants';
import { List as IList } from 'immutable';

const initialState = IList();

/**
 * ## terms reducer
 * @param {Object} state - initialState
 * @param {Object} action - type and data
 */
export default function terms (state = initialState, action = null) {
  switch (action.type) {
    /**
     * ### REQUESTS (start)
     */
    case Constants.NAVIGATION_REQUEST:
      return initialState;

    /**
     * ### SUCCESS (request ended with success)
     */
    case Constants.NAVIGATION_SUCCESS:
      return IList(action.data);

    /**
     * ### FAILURE (request ended with error)
     */
    case Constants.NAVIGATION_FAILURE:
      return initialState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/NavigationReducer.js